import { useDataGridOptions } from "@biggeo/bg-ui/lab";
import isEmpty from "lodash/isEmpty";

import { useFetchFileGenerationConnectionQuery } from "@biggeo/bg-server-lib/studio";
import GeneratedFilesView from "../views/GeneratedFilesView";

const GeneratedFilesContainer = () => {
    const {
        filterSearchPaginateProps,
        dataGridFetchInputProps: { sortModel, ...rest },
    } = useDataGridOptions(20);

    const {
        queryReturn: { data, loading },
    } = useFetchFileGenerationConnectionQuery({
        variables: {
            input: {
                options: rest,
            },
        },
    });

    return (
        <GeneratedFilesView
            data={data?.fetchFileGenerationConnection || []}
            loading={loading}
            pagination={filterSearchPaginateProps}
        />
    );
};

export default GeneratedFilesContainer;
